
<ng-container *ngIf="!isLoggedIn">
  <div style="    border-right: 2px solid #ddd;">
    <div style="    margin-bottom: 15px;
  margin-top: 20px;
">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">New Arrivals</p>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLastDate(30)" >Last 30 days</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLastDate(60)">Last 60 days</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLastDate(90)">Last 90 days</a>
    </div> 
    
  </div>

  <div style="    margin-bottom: 15px;">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Languages</p>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('ENGLISH')">English</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('HINDI')">Hindi</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('BILINGUAL')">Bilingual</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('MISCELLANEOUS')">Miscellaneous</a>
    </div>
    <!-- <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('TAMIL')">Tamil</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('TELUGU')">Telugu</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('KANNADA')">Kannada</a>
    </div> -->
  
    
    
    
    
  </div>

  <div style="    margin-bottom: 15px;" *ngIf="authorsList && authorsList.length">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Author</p>
    <ng-container *ngFor="let author of authorsList">
      <div style="margin-bottom: 4px;">
        <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnAuthorId(author)">{{author}}</a>
      </div>
    </ng-container>
  </div>

  <div style="    margin-bottom: 15px;">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Ratings</p>
    <a style="    margin-bottom: 0px; cursor: pointer;   display: flex;" (click)="filterOnRating(5)">
      <span style="pointer-events: none;"><bar-rating class="star" [rate]="'5'" [max]="'5'"></bar-rating></span> <span style="    margin: auto;
      margin-left: 10px;">& Up</span>
    </a>
    <a style="    margin-bottom: 0px;  cursor: pointer;  display: flex;" (click)="filterOnRating(4)">
      <span style="pointer-events: none;"><bar-rating class="star" [rate]="'4'" [max]="'5'"></bar-rating></span> <span style="    margin: auto;
      margin-left: 10px;">& Up</span>
    </a>
    <a style="    margin-bottom: 0px; cursor: pointer;  display: flex;" (click)="filterOnRating(3)">
      <span style="pointer-events: none;"><bar-rating class="star" [rate]="'3'" [max]="'5'"></bar-rating></span> <span style="    margin: auto;
      margin-left: 10px;">& Up</span>
    </a>
    <a style="    margin-bottom: 0px;  cursor: pointer;  display: flex;" (click)="filterOnRating(2)">
      <span style="pointer-events: none;"><bar-rating class="star" [rate]="'2'" [max]="'5'"></bar-rating></span> <span style="    margin: auto;
      margin-left: 10px;">& Up</span>
    </a>
    <a style="    margin-bottom: 0px; cursor: pointer;   display: flex;" (click)="filterOnRating(1)">
      <span style="pointer-events: none;"><bar-rating class="star" [rate]="'1'" [max]="'5'"></bar-rating></span> <span style="    margin: auto;
      margin-left: 10px;">& Up</span>
    </a>
  </div>

  <div style="    margin-bottom: 15px;">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Price</p>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;"  (click)="filterOnPrice(0, 99)">Under ₹100 </a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnPrice(100, 199)">₹100 - ₹200</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnPrice(200, 499)">₹200 - ₹500</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnPrice(500, 999)">₹500 - ₹1,000</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnPrice(1000, 99999999)">Over ₹1,000</a>
    </div>
    
  </div>

  <div style="    margin-bottom: 15px;">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Discount</p>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(10)">10% Off or more</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(25)">25% Off or more</a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(35)">35% Off or more</a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(50)">50% Off or more</a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(60)">60% Off or more</a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(70)">70% Off or more</a>
      
    </div>


    
  </div>

  <div  style="    margin-bottom: 15px;">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Important Links</p>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;color: #444444;" (click)="redirect('/books/type/bestseller')">Best Seller</a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;color: #444444;" (click)="redirect('/books/type/combo')">Combo </a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;color: #444444;" (click)="redirect('/books/type/new')">New Arrival </a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;color: #444444;" (click)="redirect('/books/type/upcoming')">Coming soon </a>
      
    </div>
    <!-- <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;color: #444444;" (click)="redirect('/books/type/offerzone')">Offer's zone </a>
      
    </div> -->
  </div>


  <div style="margin-top: 30px;" *ngIf="ComboBooksData && ComboBooksData.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of ComboBooksData">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;min-height: 100px; background: #F3F4F9;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>

  <div style="margin-top: 30px;" *ngIf="newArrivalsBooks && newArrivalsBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of newArrivalsBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;min-height: 100px; background: #F3F4F9;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>


  <div style="margin-top: 30px;" *ngIf="BooksData && BooksData.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of BooksData">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;min-height: 100px; background: #F3F4F9;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>

 

  <!-- <div style="margin-top: 30px;" *ngIf="upscBooks && upscBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of upscBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>

  <div style="margin-top: 30px;" *ngIf="sscBooks && sscBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of sscBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>

  <div style="margin-top: 30px;" *ngIf="bankBooks && bankBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of bankBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>

  <div style="margin-top: 30px;" *ngIf="ncertBooks && ncertBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of ncertBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div> -->

  <div style="margin-top: 30px;" *ngIf="upcomingBooks && upcomingBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of upcomingBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; 
                  padding-bottom: 10px;min-height: 100px; background: #F3F4F9;">
      </div>
    </marquee>
  </div>


  </div>
</ng-container>

<ng-container *ngIf="isLoggedIn">
  <div style="    border-right: 2px solid #ddd;">
    <div style="    margin-bottom: 15px;
  margin-top: 20px;
">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">New Arrivals</p>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLastDate(30)" >Last 30 days</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLastDate(60)">Last 60 days</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLastDate(90)">Last 90 days</a>
    </div> 
    
  </div>

  <div style="    margin-bottom: 15px;">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Languages</p>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('ENGLISH')">English</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('HINDI')">Hindi</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('BILINGUAL')">Bilingual</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('MISCELLANEOUS')">Miscellaneous</a>
    </div>
    <!-- <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('MARATHI')">Marathi</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('TAMIL')">Tamil</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('TELUGU')">Telugu</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnLanguage('KANNADA')">Kannada</a>
    </div> -->
  
    
    
    
    
  </div>

  <div style="    margin-bottom: 15px;" *ngIf="authorsList && authorsList.length">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Author</p>
    <ng-container *ngFor="let author of authorsList">
      <div style="margin-bottom: 4px;">
        <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnAuthorId(author)">{{author}}</a>
      </div>
    </ng-container>
  </div>

  <!-- <div style="    margin-bottom: 15px;">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Ratings</p>
    <a style="    margin-bottom: 0px; cursor: pointer;   display: flex;" (click)="filterOnRating(5)">
      <span style="pointer-events: none;"><bar-rating class="star" [rate]="'5'" [max]="'5'"></bar-rating></span> <span style="    margin: auto;
      margin-left: 10px;">& Up</span>
    </a>
    <a style="    margin-bottom: 0px;  cursor: pointer;  display: flex;" (click)="filterOnRating(4)">
      <span style="pointer-events: none;"><bar-rating class="star" [rate]="'4'" [max]="'5'"></bar-rating></span> <span style="    margin: auto;
      margin-left: 10px;">& Up</span>
    </a>
    <a style="    margin-bottom: 0px; cursor: pointer;  display: flex;" (click)="filterOnRating(3)">
      <span style="pointer-events: none;"><bar-rating class="star" [rate]="'3'" [max]="'5'"></bar-rating></span> <span style="    margin: auto;
      margin-left: 10px;">& Up</span>
    </a>
    <a style="    margin-bottom: 0px;  cursor: pointer;  display: flex;" (click)="filterOnRating(2)">
      <span style="pointer-events: none;"><bar-rating class="star" [rate]="'2'" [max]="'5'"></bar-rating></span> <span style="    margin: auto;
      margin-left: 10px;">& Up</span>
    </a>
    <a style="    margin-bottom: 0px; cursor: pointer;   display: flex;" (click)="filterOnRating(1)">
      <span style="pointer-events: none;"><bar-rating class="star" [rate]="'1'" [max]="'5'"></bar-rating></span> <span style="    margin: auto;
      margin-left: 10px;">& Up</span>
    </a>
  </div> -->

  <div style="    margin-bottom: 15px;">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Price</p>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;"  (click)="filterOnPrice(0, 99)">Under ₹100 </a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnPrice(100, 199)">₹100 - ₹200</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnPrice(200, 499)">₹200 - ₹500</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnPrice(500, 999)">₹500 - ₹1,000</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnPrice(1000, 99999999)">Over ₹1,000</a>
    </div>
    
  </div>

  <div style="    margin-bottom: 15px;">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Discount</p>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(10)">10% Off or more</a>
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(25)">25% Off or more</a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(35)">35% Off or more</a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(50)">50% Off or more</a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(60)">60% Off or more</a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;" (click)="filterOnDiscount(70)">70% Off or more</a>
      
    </div>


    
  </div>

  <div  style="    margin-bottom: 15px;">
    <p style="    margin-bottom: 10px;    color: #0F1111!important;
    font-size: 14px!important;
    line-height: 20px!important;
    font-weight: 700!important;">Important Links</p>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;color: #444444;" (click)="redirect('/user/user-books/type/bestseller')">Best Seller</a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;color: #444444;" (click)="redirect('/user/user-books/type/combo')">Combo </a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;color: #444444;" (click)="redirect('/user/user-books/type/new')">New Arrival </a>
      
    </div>
    <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;color: #444444;" (click)="redirect('/user/user-books/type/upcoming')">Coming soon </a>
      
    </div>
    <!-- <div style="margin-bottom: 4px;">
      <a style="    margin-bottom: 0px;cursor: pointer;color: #444444;" (click)="redirect('/user/user-books/type/offerzone')">Offer's zone </a>
      
    </div> -->
  </div>


  <div style="margin-top: 30px;" *ngIf="ComboBooksData && ComboBooksData.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of ComboBooksData">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;min-height: 100px; background: #F3F4F9;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>

  <div style="margin-top: 30px;" *ngIf="newArrivalsBooks && newArrivalsBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of newArrivalsBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;min-height: 100px; background: #F3F4F9;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>


  <div style="margin-top: 30px;" *ngIf="BooksData && BooksData.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of BooksData">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;min-height: 100px; background: #F3F4F9;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>

 

  <!-- <div style="margin-top: 30px;" *ngIf="upscBooks && upscBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of upscBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>

  <div style="margin-top: 30px;" *ngIf="sscBooks && sscBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of sscBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>

  <div style="margin-top: 30px;" *ngIf="bankBooks && bankBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of bankBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div>

  <div style="margin-top: 30px;" *ngIf="ncertBooks && ncertBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of ncertBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; cursor: pointer;
                  padding-bottom: 10px;"  (click)="openDetail(book)">
      </div>
    </marquee>
  </div> -->

  <div style="margin-top: 30px;" *ngIf="upcomingBooks && upcomingBooks.length">
    <marquee onmouseover="this.stop()"  onmouseout="this.start()" direction="down" height="430px" style="overflow:hidden;">
      <div  *ngFor="let book of upcomingBooks">
        <img src="{{book.image}}" style="width: 100%;max-width: 200px; 
                  height: auto; 
                  padding-bottom: 10px;min-height: 100px; background: #F3F4F9;">
      </div>
    </marquee>
  </div>


  </div>
</ng-container>